<template>
  <Dialog
    :visible="open"
    modal
    :header="episode.title"
    class="w-11 sm:w-9 md:w-8 lg:w-7 xl:w-5"
    :closable="false"
  >
    <div class="w-full h-15rem flex justify-content-center mb-3">
      <img
        :src="episode.image_url"
        alt="Episode Image"
        style="object-fit: contain"
      />
    </div>
    <p>
      <span class="text-color-secondary">Description</span><br />
      <span class="text-color">{{ episode.description }}</span>
    </p>
    <p>
      <span class="text-color-secondary">Publicated at</span><br />
      <span class="text-color">{{ episode.publication_date }}</span>
    </p>
    <p>
      <span class="text-color-secondary">Episode Link</span><br />
      <a class="text-color" target="_blank" :href="episode.episode_link">{{
        episode.episode_link
      }}</a>
    </p>
    <p>
      <span class="text-color-secondary">Media Link</span><br />
      <a class="text-color" target="_blank" :href="episode.media_url">{{
        episode.media_url
      }}</a>
    </p>
    <p>
      <span class="text-color-secondary">Media Type</span><br />
      <span class="text-color">{{ episode.media_type }}</span>
    </p>
    <p>
      <span class="text-color-secondary">Duration</span><br />
      <span class="text-color">{{ episode.duration }}</span>
    </p>
    <p>
      <span class="text-color-secondary">Keywords</span><br />
      <span class="text-color">{{ episode.keywords }}</span>
    </p>
    <p>
      <span class="text-color-secondary">Author</span><br />
      <span class="text-color">{{ episode.author }}</span>
    </p>
    <template #footer>
      <div class="flex justify-content-end gap-2 mt-2">
        <Button
          type="button"
          label="Close"
          severity="secondary"
          @click="$emit('close')"
        ></Button>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

const props = defineProps(["episode", "open"]);
const emit = defineEmits(["close"]);
</script>
